import { LANGUAGES } from "../api-sdk/types";
import { logger } from "../utils/logger";
import { BeamError } from "../utils/beam-errors";

/**
 * User-provided strings may include embedded translations in JSON form
 * This function extracts the string for the provided language
 * If it fails to parse, or the string is not json-like, it returns the whole string
 */
const localizeUserString = (lang: LANGUAGES, str: string): string => {
  const isJson = str.startsWith("{");
  if (isJson) {
    try {
      const json = JSON.parse(str);
      return json[lang] ?? json["en"] ?? str;
    } catch (err) {
      logger.error(new BeamError("Failed to extract JSON translation from string"), str);
      return str;
    }
  }
  return str;
};

export { localizeUserString };
